<div class="datiq-cell-graph-value">
    <datiq-graph-card-chart [settings]="settings?.chart"></datiq-graph-card-chart>
</div>
